import { briefingApi } from '@/apis';
import { useQuery } from '@tanstack/react-query';

export function useNotices(options) {
  const searchParams = JSON.parse(JSON.stringify(options ?? {}));

  return useQuery({
    queryKey: ['notices', searchParams],
    queryFn: () => {
      return briefingApi.get('notices', { searchParams }).json();
    },
    placeholderData: [],
  });
}
